// === Simulateur de toiture – Version API (prix dynamiques) ===
(function(){
  if (window.__roofSimBound) return;
  window.__roofSimBound = true;

  const W_TOLE = 1.10; // largeur utile (m)
  const PAS = 0.35;    // pas tôle (m)
  const fmt = n => (Math.round((n + Number.EPSILON) * 100) / 100).toFixed(2).replace('.', ',');
  const $ = s => document.querySelector(s);

  // Témoins visuels
  const st = $('#sim-status'); if (st) st.textContent = 'JS chargé ✓ (API)';

  // Chargement des configs (handles + noms d’options)
  function readJSON(id, fallback){ try{ return JSON.parse(document.getElementById(id).textContent.trim()); }catch(e){ return fallback; } }
  const PRODUCT = readJSON('productHandles', {});
  const OPTNAMES = readJSON('optionNames', {  colorOptionNames: ['Couleur'],
  lengthOptionNames: [
    'Longueur',
    'Longueur de gouttière',
    'Longueur de gouttiere',   // au cas où sans accent
    'Longueur gouttière',
    'Longueur gouttiere'
  ],
  sizeOptionNames: ['Largeur de gouttière','Largeur de gouttiere'] // optionnel, ne gêne pas
});


  // Utils options : détecter l’index Couleur / Longueur dans un product.js
function optionIndexByName(product, candidateNames){
  const names = (product.options || []).map(o => {
    // /products/xxx.js renvoie souvent un tableau de strings
    const n = (typeof o === 'string') ? o : (o && o.name) ? o.name : '';
    return n.toLowerCase().trim();
  });

  for (let i = 0; i < names.length; i++){
    for (const cand of candidateNames){
      if (names[i] === String(cand).toLowerCase().trim()) return i;
    }
  }
  return -1;
}


  // Normalise une valeur "2.20" / "2,20" / "2,2" -> "2.20"
  function normNumStr(x){
    if (typeof x !== 'string') x = String(x||'');
    x = x.replace(',', '.').replace(/[^\d.]/g,'');
    const v = parseFloat(x);
    if (!isFinite(v)) return '';
    return v.toFixed(2);
  }
  function prettyMeters(x){ const v = parseFloat(normNumStr(x)||'0'); return fmt(v) + ' m'; }

  // ------- Lecture du formulaire -------
  function getVals(){
    const type = ($('#type')?.value || '1');          // "1" | "2" | "2a"
    const A = parseFloat(($('#A').value || '0').replace(',', '.')) || 0;
    const B = parseFloat(($('#B').value || '0').replace(',', '.')) || 0;
    const B2 = parseFloat(($('#B2')?.value || '0').replace(',', '.')) || 0;
    const couleur = ($('#couleur')?.value || '').toString();
    const opt_g = !!$('#opt_gouttiere')?.checked;
    const opt_b = !!$('#opt_bordure')?.checked;
    const couleur_gouttiere = ($('#couleur_gouttiere')?.value || '').toString();


    // options avancées
    const opt_larmier = !!$('#opt_larmier')?.checked;
    const opt_bordure_collecteur = !!$('#opt_bordure_collecteur')?.checked;
    const collecteur_len = parseFloat(($('#collecteur_len')?.value || '0').replace(',', '.')) || 0;
    const opt_collecteur_mur = !!$('#opt_collecteur_mur')?.checked;
    const collecteur_pans = Math.max(0, parseInt($('#collecteur_pans')?.value || '0', 10) || 0);

    return { type, A, B, B2, couleur, couleur_gouttiere, opt_g, opt_b,
             opt_larmier, opt_bordure_collecteur, collecteur_len,
             opt_collecteur_mur, collecteur_pans };
  }

  // --- Règles métier tôles ---
  // Construit la liste des longueurs < 5 m depuis productHandles.toles_by_length
  const TOLE_SHORT_LENGTHS = Object.keys(PRODUCT.toles_by_length || {})
    .map(k => parseFloat(k))
    .filter(v => isFinite(v) && v < 5.01)
    .sort((a,b)=>a-b);

  // Renvoie { mode, lengths[] } selon B (zéro tolérance côté handle)
 function calcLongueursTole(B) {
  const b = Math.round((parseFloat(String(B).replace(',', '.')) || 0) * 100) / 100;
  const r2 = n => Math.round((n + Number.EPSILON) * 100) / 100;

  // CAS 1 — B <= 5,00 m : 1 plaque
  if (b <= 5.00) {
    if (!TOLE_SHORT_LENGTHS.length) {
      return { mode: '1x', lengths: [b] };
    }
    const L = TOLE_SHORT_LENGTHS.find(x => b <= x) || TOLE_SHORT_LENGTHS[TOLE_SHORT_LENGTHS.length - 1];
    return { mode: '1x', lengths: [r2(L)] };
  }

  // Calcul en centimètres pour éviter les erreurs de virgule flottante
  const bCm = Math.round(b * 100);     // ex 9.90 -> 990
  const stepCm = 35;                   // 0.35 m
  const baseCm = 10;                   // 0.10 m

  // équivalent de ceil((b - 0.10) / 0.35) sans bug flottant
  const N = Math.floor(((bCm - baseCm) + stepCm - 1) / stepCm);

  // CAS 2 — 5,00 < B <= 9,90 → 2 plaques
  if (b <= 9.90) {
    if (N % 2 === 0) {
      const L = r2(((N / 2) * 0.35) + 0.10);
      return { mode: '2x_equal', lengths: [L, L] };
    } else {
      const L1 = r2((((N / 2) - 0.5) * 0.35) + 0.10);
      const L2 = r2((((N / 2) + 0.5) * 0.35) + 0.10);
      return { mode: '2x_split', lengths: [L1, L2] };
    }
  }

  // CAS 3 — 9,90 < B <= 14,80 → 3 plaques
  if (b <= 14.80) {
    if (N % 3 === 0) {
      const L = r2(((N / 3) * 0.35) + 0.10);
      return { mode: '3x_equal', lengths: [L, L, L] };
    } else {
      const K = Math.round(N / 3);
      const L1 = r2((K * 0.35) + 0.10);
      const L2 = r2(((N - (2 * K)) * 0.35) + 0.10);
      return { mode: '3x_split', lengths: [L1, L1, L2] };
    }
  }

  // Sécurité (> 14,80)
  const L = r2(((N / 3) * 0.35) + 0.10);
  return { mode: '3x_equal', lengths: [L, L, L] };
}
  // ------- Fetch produit par handle -------
  async function fetchProduct(handle){
    if (!handle) return null;
    try{
      const res = await fetch(`/products/${handle}.js`, { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return null;
      return await res.json(); // {title, options[], variants[] (price in cents, option1..)}
    }catch(e){ return null; }
  }

  // ------- Trouver la variante qui matche Couleur / Longueur / Taille -------
  function findVariant(product, { color, length, size }) {
    if (!product?.variants?.length) return null;

    const cIdx = optionIndexByName(product, OPTNAMES.colorOptionNames);
    const lIdx = optionIndexByName(product, OPTNAMES.lengthOptionNames);
    const sIdx = optionIndexByName(product, OPTNAMES.sizeOptionNames || []);

    const toLower = s => (s || '').toString().toLowerCase();
    const normStr = s => toLower(s).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const ralDigits = s => {
      const m = normStr(s).match(/ral[\s\-]?(\d{4})/);
      return m ? m[1] : '';
    };
    const wantRal = (color ? color.replace(/^ral[-\s]?/i, '') : '').replace(/\s/g, '');

    function variantMatches(v) {
      let ok = true;

      if (cIdx >= 0 && color) {
        const optVal = v[`option${cIdx + 1}`] || '';
        const gotRal = ralDigits(optVal);
        if (gotRal) ok = ok && (gotRal === wantRal);
        else {
          const lhs = normStr(optVal).replace(/[\s\-]/g,'');
          const rhs = normStr(color).replace(/[\s\-]/g,'');
          ok = ok && (lhs.includes(rhs) || lhs.includes(wantRal));
        }
      }

      if (lIdx >= 0 && length) {
        const want = parseFloat(normNumStr(length));
        const val = v[`option${lIdx + 1}`] || '';
        const got = parseFloat(normNumStr(val));
        ok = ok && (isFinite(got) && Math.abs(got - want) < 0.01);
      }

      if (sIdx >= 0 && size) {
        const lhs = normStr(v[`option${sIdx + 1}`] || '').replace(/\s/g,'');
        const rhs = normStr(size).replace(/\s/g,'');
        ok = ok && lhs.includes(rhs);
      }

      return ok;
    }

    let cand = product.variants.find(variantMatches);
    if (cand) return cand;

    if (cIdx >= 0 && color) {
      cand = product.variants.find(v => {
        const gotRal = ralDigits(v[`option${cIdx + 1}`] || '');
        if (gotRal) return gotRal === wantRal;
        const lhs = normStr(v[`option${cIdx + 1}`] || '').replace(/[\s\-]/g,'');
        const rhs = normStr(color).replace(/[\s\-]/g,'');
        return lhs.includes(rhs) || lhs.includes(wantRal);
      });
      if (cand) return cand;
    }

    return product.variants[0] || null;
  }

  // ------- Cache produit -------
  const __productCache = new Map();
  async function getProductCached(handle){
    if (!handle) return null;
    if (__productCache.has(handle)) return __productCache.get(handle);
    const p = await fetchProduct(handle);
    __productCache.set(handle, p);
    return p;
  }

  // Parse "2,20" -> 2.20
  function parseLen(x){
    return parseFloat(String(x || '').replace(',', '.'));
  }

  // ZÉRO tolérance : la clé doit exister au centimètre près (2 décimales)
  function getToleHandleForLength(L){
    const map = PRODUCT.toles_by_length || {};
    if (!map || !Object.keys(map).length) return null;
    const keyExact = L.toFixed(2);
    if (map[keyExact]) return map[keyExact];
    console.warn('[roof-sim] Handle tôle exact introuvable pour', keyExact, '— clés dispo:', Object.keys(map));
    return null;
  }
// nom gouttiere patch
function findVariantGouttiere(product, { color, length }) {
  if (!product?.variants?.length) return null;

  const norm = (s) => (s || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');
  const wantRal = norm(color).match(/ral\s*([0-9]{4})/i)?.[1] || '';
  const wantLenDot = (String(length || '').replace(',', '.').match(/[0-9]+(?:\.[0-9]+)?/) || [''])[0]; // ex "10.20"
  const wantLenComma = wantLenDot ? wantLenDot.replace('.', ',') : '';

  // 1) on cherche une variante dont AU MOINS une option contient la longueur (10.20 ou 10,20)
  let candidates = product.variants.filter(v => {
    const opts = [v.option1, v.option2, v.option3].map(norm);
    return opts.some(o => wantLenDot && (o.includes(wantLenDot) || (wantLenComma && o.includes(wantLenComma))));
  });

  if (!candidates.length) return product.variants[0] || null;

  // 2) si on a la couleur, on filtre aussi par RAL (si présent dans les options)
  if (wantRal) {
    const byColor = candidates.filter(v => {
      const opts = [v.option1, v.option2, v.option3].map(norm);
      return opts.some(o => o.includes(wantRal));
    });
    if (byColor.length) candidates = byColor;
  }

  return candidates[0] || product.variants[0] || null;
}

  // ------- Conversion lignes -> items + PU via API (tôles par longueur) -------
  async function rowsToItemsWithPrices(rows, ctx){
    const items = [];
    
    const products = {
      faitage:   await fetchProduct(PRODUCT.faitage),
      fronton:   await fetchProduct(PRODUCT.fronton),
      closoir:   await fetchProduct(PRODUCT.closoir),
      bordure:   await fetchProduct(PRODUCT.bordure),
      vis:       await fetchProduct(PRODUCT.vis),
      gouttiere: await fetchProduct(PRODUCT.gouttiere),
      about:     await fetchProduct(PRODUCT.about),

      // nouveaux produits (si handles fournis)
      larmier_mur:        await fetchProduct(PRODUCT.larmier_mur),
      bordure_collecteur: await fetchProduct(PRODUCT.bordure_collecteur),
      collecteur_mur:     await fetchProduct(PRODUCT.collecteur_mur)
    };

    for (const r of rows){
      const name = r.nom || '';
      let product = null, variant = null, quantity = r.nb, pu_cents = 0, pu_text = '-', props = {};

      if (/^Tôles /.test(name)){
        const L = parseLen(r.longueur);
        const handle = getToleHandleForLength(L);
        if (!handle){
          console.warn('Handle tôle introuvable pour longueur', r.longueur, PRODUCT.toles_by_length);
          r.pu_text = '-'; r.total = 0;
          continue;
        }
        product = await getProductCached(handle);
        variant = findVariant(product, { color: ctx.couleur });
        pu_cents = variant ? parseInt(variant.price,10) : 0;
        pu_text  = variant ? fmt(pu_cents/100)+' €' : '-';
        props = {
          'Longueur (m)': (r.longueur||'').toString(),
          'Largeur utile (m)': '1.10',
          'Couleur': ctx.couleur || 'standard'
        };

      } else if (name === 'Faîtage'){
        product = products.faitage;
        variant = findVariant(product, { color: ctx.couleur });
        pu_cents = variant ? parseInt(variant.price,10) : 0;
        pu_text  = variant ? fmt(pu_cents/100)+' €' : '-';
        props = { 'Longueur (m)': '2.00' };

      } else if (name === 'About de faîtage'){
        product = products.about;
        variant = findVariant(product, { color: ctx.couleur });
        pu_cents = variant ? parseInt(variant.price,10) : 0;
        pu_text  = variant ? fmt(pu_cents/100)+' €' : '-';

      } else if (name === 'Fronton'){
        product = products.fronton;
        variant = findVariant(product, { color: ctx.couleur });
        pu_cents = variant ? parseInt(variant.price,10) : 0;
        pu_text  = variant ? fmt(pu_cents/100)+' €' : '-';
        props = { 'Longueur (m)': '2.00' };

      } else if (name === 'Closoir'){
        product = products.closoir;
        variant = findVariant(product, { color: ctx.couleur });
        pu_cents = variant ? parseInt(variant.price,10) : 0;
        pu_text  = variant ? fmt(pu_cents/100)+' €' : '-';
        props = { 'Longueur (m)': '5.00' };

      } else if (name === 'Bordure basse'){
        product = products.bordure;
        variant = findVariant(product, { color: ctx.couleur });
        pu_cents = variant ? parseInt(variant.price,10) : 0;
        pu_text  = variant ? fmt(pu_cents/100)+' €' : '-';
        props = { 'Longueur (m)': '2.00' };

      } else if (name === 'Vis 4.8x35 (boîte 250)'){
        product = products.vis;
        variant = findVariant(product, { color: ctx.couleur, size: '4.8x35' });
        pu_cents = variant ? parseInt(variant.price,10) : 0;
        pu_text  = variant ? fmt(pu_cents/100)+' €' : '-';

      } else if (name === 'Vis 4.8x20 (boîte 250)'){
        product = products.vis;
        variant = findVariant(product, { color: ctx.couleur, size: '4.8x20' });
        pu_cents = variant ? parseInt(variant.price,10) : 0;
        pu_text  = variant ? fmt(pu_cents/100)+' €' : '-';

      } else if (name === 'Larmier de mur faitage'){
        product = products.larmier_mur;
        variant = findVariant(product, { color: ctx.couleur });
        pu_cents = variant ? parseInt(variant.price,10) : 0;
        pu_text  = variant ? fmt(pu_cents/100)+' €' : '-';
        props = { 'Longueur (m)': '2.00' };

      } else if (name === 'Bordure collecteur de fronton'){
        product = products.bordure_collecteur;
        variant = findVariant(product, { color: ctx.couleur });
        pu_cents = variant ? parseInt(variant.price,10) : 0;
        pu_text  = variant ? fmt(pu_cents/100)+' €' : '-';
        props = { 'Longueur (m)': '2.00' };

      } else if (name === 'Larmier mur pente fixbac'){
        product = products.collecteur_mur;
        variant = findVariant(product, { color: ctx.couleur });
        pu_cents = variant ? parseInt(variant.price,10) : 0;
        pu_text  = variant ? fmt(pu_cents/100)+' €' : '-';
        props = { 'Longueur (m)': '2.00' };

      } else {
        // Kit gouttière (palier dans le nom)
const m = name.match(/Kit gouttière zinc jusqu'à ([\d,]+) m/);
if (m){
  product = products.gouttiere;

  const pal = (m[1] || '').trim(); // ex: "10,20"
  const gouttColor = (ctx.couleur_gouttiere || '').trim() || ctx.couleur; // vide => même que toiture

  variant = findVariantGouttiere(product, { color: gouttColor, length: pal });
  pu_cents = variant ? parseInt(variant.price,10) : 0;
  pu_text  = variant ? fmt(pu_cents/100)+' €' : '-';

  props = {    'Palier (m)': pal,    'Couleur gouttière': gouttColor  };
}

      }

      const total = (pu_cents/100) * (quantity||0);
      r.pu_text = pu_text;
      r.total   = total;

      if (variant?.id && quantity > 0){
        const item = { id: variant.id, quantity: quantity };
        if (props && Object.keys(props).length) item.properties = props;
        items.push(item);
      } else if (/^Tôles /.test(name)) {
        console.warn('Variante tôle introuvable (couleur ?)', { row: r, ctx });
      }
    }

    return { items, rows };
  }

  // ------- Construction des lignes "quantités" (sans prix) -------
  function buildQuantityRows(v){
    const rows = [];
    const fmt2 = x => (Math.round((x + Number.EPSILON) * 100) / 100).toFixed(2).replace('.', ',');
    const across = A => Math.ceil((A - 0.10) / 1.10);

    const isTwoSym = (v.type === '2');
    const isTwoAsym = (v.type === '2a');

    // ===== Faîtage & About =====
    if (isTwoSym || isTwoAsym){
      const nbFaitage = Math.ceil((v.A + 0.10) / 1.90);
      if (nbFaitage > 0) rows.push({ nom:'Faîtage', longueur:'2,00', nb: nbFaitage });

      const nbAbout = 2;
      if (nbAbout > 0) rows.push({ nom:'About de faîtage', longueur:'-', nb: nbAbout });
    }

    // ===== Frontons =====
    if (!isTwoSym && !isTwoAsym){
      const nbFronton = Math.ceil(((v.A + 2*v.B) / 1.9));
      if (nbFronton > 0) rows.push({ nom:'Fronton', longueur:'2,00', nb: nbFronton });
    } else if (isTwoSym){
      const nbFronton = Math.ceil(((4 * v.B) / 1.9));
      if (nbFronton > 0) rows.push({ nom:'Fronton', longueur:'2,00', nb: nbFronton });
    } else {
      const nbFronton = Math.ceil((2 * (v.B + v.B2 - 0.10)) / 1.90);
      if (nbFronton > 0) rows.push({ nom:'Fronton', longueur:'2,00', nb: nbFronton });
    }

    // ===== Closoir =====
    if (isTwoSym || isTwoAsym){
      const nbClosoir = Math.ceil(v.A / 5);
      if (nbClosoir > 0) rows.push({ nom:'Closoir', longueur:'5,00', nb: nbClosoir });
    }

    // ===== Vis 4.8x35 (boîte 250) =====  (coeff = 10)
    if (!isTwoSym && !isTwoAsym){
      const nbBoites = Math.ceil((v.A * v.B * 10) / 250);
      if (nbBoites > 0) rows.push({ nom:'Vis 4.8x35 (boîte 250)', longueur:'-', nb: nbBoites });
    } else if (isTwoSym){
      const nbBoites = Math.ceil((2 * v.A * v.B * 10) / 250);
      if (nbBoites > 0) rows.push({ nom:'Vis 4.8x35 (boîte 250)', longueur:'-', nb: nbBoites });
    } else {
      const nbBoites = Math.ceil(((v.A * v.B) + (v.A * v.B2)) * 10 / 250);
      if (nbBoites > 0) rows.push({ nom:'Vis 4.8x35 (boîte 250)', longueur:'-', nb: nbBoites });
    }

    // ===== Vis 4.8x20 (boîte 250) =====  (coeff = 2.5)
    if (!isTwoSym && !isTwoAsym){
      const nbBoites20 = Math.ceil((v.A * v.B * 2.5) / 250);
      if (nbBoites20 > 0) rows.push({ nom:'Vis 4.8x20 (boîte 250)', longueur:'-', nb: nbBoites20 });
    } else if (isTwoSym){
      const nbBoites20 = Math.ceil((2 * v.A * v.B * 2.5) / 250);
      if (nbBoites20 > 0) rows.push({ nom:'Vis 4.8x20 (boîte 250)', longueur:'-', nb: nbBoites20 });
    } else {
      const nbBoites20 = Math.ceil(((v.A * v.B) + (v.A * v.B2)) * 2.5 / 250);
      if (nbBoites20 > 0) rows.push({ nom:'Vis 4.8x20 (boîte 250)', longueur:'-', nb: nbBoites20 });
    }

    // ===== Larmiers de murs faitage=====
    if (v.opt_larmier) {
      const nb = Math.ceil((v.A + 0.10) / 1.90);
      if (nb > 0) rows.push({ nom:'Larmier de mur faitage', longueur:'2.00', nb });
    }

    // ===== Bordures collecteur de fronton =====
    if (v.opt_bordure_collecteur && v.collecteur_len > 0) {
      const nb = Math.ceil((v.collecteur_len + 0.10) / 1.90);
      if (nb > 0) rows.push({ nom:'Bordure collecteur de fronton', longueur:'2.00', nb });
    }

    // ===== Collecteur fixation des bacs au mur =====
    if (v.opt_collecteur_mur && v.collecteur_pans > 0) {
      let baseLen = v.collecteur_pans * v.B;
      if (v.type === '2a' && v.collecteur_pans >= 2) {
        baseLen = (v.B + v.B2);
      }
      const nb = Math.ceil(((baseLen) + 0.10) / 1.90);
      if (nb > 0) rows.push({ nom:'Larmier mur pente fixabac', longueur:'2.00', nb });
    }

  // ===== Tôles =====
  const addToleLinesForPan = (Bval, label) => {
    const dec = calcLongueursTole(Bval);
    const nbAcross = across(v.A);
    if (dec.mode === '1x'){
      const L = dec.lengths[0];
      rows.push({ nom:`Tôles ${label} L=${fmt2(L)} m`, longueur: fmt2(L), nb: nbAcross });
    } else if (dec.mode === '2x_equal'){
      const L = dec.lengths[0];
      rows.push({ nom:`Tôles ${label} L=${fmt2(L)} m`, longueur: fmt2(L), nb: 2 * nbAcross });
    } else if (dec.mode === '2x_split'){
      const L1 = dec.lengths[0], L2 = dec.lengths[1];
      rows.push({ nom:`Tôles ${label} L=${fmt2(L1)} m`, longueur: fmt2(L1), nb: nbAcross });
      rows.push({ nom:`Tôles ${label} L=${fmt2(L2)} m`, longueur: fmt2(L2), nb: nbAcross });
    } else if (dec.mode === '3x_equal'){
      const L = dec.lengths[0];
      rows.push({ nom:`Tôles ${label} L=${fmt2(L)} m`, longueur: fmt2(L), nb: 3 * nbAcross });
    } else if (dec.mode === '3x_split'){
      const L1 = dec.lengths[0], L2 = dec.lengths[2];
      rows.push({ nom:`Tôles ${label} L=${fmt2(L1)} m`, longueur: fmt2(L1), nb: 2 * nbAcross });
      rows.push({ nom:`Tôles ${label} L=${fmt2(L2)} m`, longueur: fmt2(L2), nb: nbAcross });
    }
  };

  if (!isTwoSym && !isTwoAsym){
    // 1 pan
    addToleLinesForPan(v.B, '(pan 1)');
  } else if (isTwoSym){
    const beforeLen = rows.length;
    addToleLinesForPan(v.B, '');
    for (let i = beforeLen; i < rows.length; i++){
      if (rows[i].nom.startsWith('Tôles ')){
        rows[i].nb = rows[i].nb * 2;
        rows[i].nom = rows[i].nom.replace('Tôles  L=', 'Tôles L=');
      }
    }
  } else {
    // 2 pans asym
    addToleLinesForPan(v.B, '(pan 1)');
    addToleLinesForPan(v.B2, '(pan 2)');
  }

 // ===== Gouttière (kits auto) =====
if (v.opt_g) {
  const kits = chooseGouttiereKits(v.A);                 // découpe en paliers 3.40 / 5.10 / ...
  const panFactor = (isTwoSym || isTwoAsym) ? 2 : 1;     // 2 pans → on double le nb de kits
  for (const k of kits) {
    rows.push({
      nom: `Kit gouttière zinc jusqu'à ${fmt2(k.max)} m`,
      longueur: fmt2(k.max),
      nb: k.qty_per_pan * panFactor
    });
  }
}

// ===== Bordure basse (indépendante) =====
// Règle demandée :
// - 1 pan           : nb = ceil( (A + 0.10) / 1.90 )
// - 2 pans / 2a     : nb = ceil( (2*A + 0.20) / 1.90 )
if (v.opt_b) {
  const isTwo = (isTwoSym || isTwoAsym);
  const lenEff = isTwo ? (2 * v.A + 0.20) : (v.A + 0.10);
  const nbBord = Math.ceil(lenEff / 1.90);
  if (nbBord > 0) {
    // Affichage 2,00 m (longueur commerciale), calcul 1,90 m (recouvrement)
    rows.push({ nom: 'Bordure basse', longueur: '2,00', nb: nbBord });
  }
}



  return rows;
  }
  // (La partition gouttière est prête si tu l’utilises)
  function chooseGouttiereKits(A){
    const paliers = [3.40, 5.10, 6.80, 8.50, 10.20, 11.90, 13.60];
    const out = [];
    const max = paliers[paliers.length-1];

    if (A <= max){
      const p = paliers.find(x => A <= x) || max;
      out.push({ max: p, qty_per_pan: 1 });
      return out;
    }
    const fullCount = Math.floor(A / max);
    const rem = A - fullCount * max;
    if (fullCount > 0) out.push({ max: max, qty_per_pan: fullCount });
    if (rem > 0){
      const p = paliers.find(x => rem <= x) || max;
      out.push({ max: p, qty_per_pan: 1 });
    }
    return out;
  }

  // Rendu du tableau
  function renderTable(rows, v){
    let total = 0;
    rows.forEach(r => total += (r.total || 0));

    let info;
    if (v.type === '2') {
      info = `<div class="note">Résultat pour <b>2 pans symétriques</b> de faîtage <b>${fmt(v.A)} m</b> et de pan de toiture <b>${fmt(v.B)} m</b>.</div>`;
    } else if (v.type === '2a') {
      info = `<div class="note">Résultat pour <b>2 pans asymétriques</b> (faîtage <b>${fmt(v.A)} m</b>, pans <b>${fmt(v.B)} m</b> et <b>${fmt(v.B2)} m</b>).</div>`;
    } else {
      info = `<div class="note">Résultat pour <b>1 pan</b> de toiture de ${fmt(v.B)} m (faîtage ${fmt(v.A)} m).</div>`;
    }

    const thead = `<thead><tr><th>Produit</th><th>Longueur (m)</th><th>Nb</th><th>PU TTC</th><th>Total TTC</th></tr></thead>`;
    const tbody = `<tbody>${rows.map(r => `
      <tr>
        <td>${r.nom}</td>
        <td>${r.longueur || '-'}</td>
        <td>${r.nb}</td>
        <td>${r.pu_text || '-'}</td>
        <td>${fmt(r.total || 0)} €</td>
      </tr>`).join('')}
    </tbody>`;
    const tfoot = `<tfoot><tr><td colspan="4">Total général</td><td>${fmt(total)} €</td></tr></tfoot>`;
    return info + `<table>${thead}${tbody}${tfoot}</table>`;
  }

  // Calcul principal
  async function calcul(){
    const v = getVals();
    const result = $('#result');
    if (!v.A || !v.B){ result.innerHTML = '<p style="color:#b45309">Renseignez A et B.</p>'; return; }
    result.innerHTML = '<p class="hint">Calcul en cours…</p>';

    const qtyRows = buildQuantityRows(v);
    const { items, rows } = await rowsToItemsWithPrices(qtyRows, v);

    result.innerHTML = '<h3>Récapitulatif</h3>' + renderTable(rows, v);
    window.__roofSimLast = { rows, ctx: v, items };
  }

  // Ajouter au panier
  async function addItemsToCart(items, openCart){
    if (!items?.length){ alert('Veuillez d’abord lancer un calcul.'); return; }
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ items })
    });
    if (!res.ok){
      const txt = await res.text().catch(()=> '');
      console.error('cart/add.js error', txt);
      alert('Erreur pendant l’ajout au panier. Vérifiez vos variants/handles.');
      return;
    }
    if (openCart){ location.href = '/cart'; }
    else { alert('Articles ajoutés au panier.'); }
  }

  // Listeners
  $('#btnCalc')?.addEventListener('click', ()=>{ calcul(); });
  $('#btnAddToCart')?.addEventListener('click', async ()=>{
    if (!window.__roofSimLast) await calcul();
    const snap = window.__roofSimLast;
    const openCart = !!$('#open_cart_after')?.checked;
    await addItemsToCart(snap.items, openCart);
  });

  // (Option) cacher la section Tests si elle existe
  document.querySelectorAll('details.test').forEach(el => { el.style.display = 'none'; });
})();
